<template><App :keepAliveInclude="keepAliveInclude"/></template><script>
	import {getAccountInfoSync,getSystemInfoSync,getNavBarInfo,getCurrentAppMode} from '@/lib/appInfo.js'
	import api from '@/lib/api.js'
	import {initAppParams} from '@/lib/appParams.js'
	
	export default {
		onLaunch: function(e) {
			console.log('[config] ****************************');
			console.log('[config] Base API: ' + process.uniEnv.baseUrl);
			console.log('[config] App Name: ' + process.uniEnv.appName);
			console.log('[config] App UUID: ' + process.uniEnv.appID);
			
			// 打印环境变量信息
			if (process.env) {
				console.log('[config] ENV Variables:');
				if (process.env.UNI_SCRIPT) {
					console.log('[config] UNI_SCRIPT: ' + process.env.UNI_SCRIPT);
				}
				if (process.env.UNI_PLATFORM) {
					console.log('[config] UNI_PLATFORM: ' + process.env.UNI_PLATFORM);
				}
				if (process.env.NODE_ENV) {
					console.log('[config] NODE_ENV: ' + process.env.NODE_ENV);
				}
			}
			
			// 获取当前编译模式信息
			const currentMode = getCurrentAppMode();
			console.log('[config] Current Mode: ' + currentMode.code + ' (' + currentMode.title + ')');
			if (currentMode.platform) {
				console.log('[config] Platform: ' + currentMode.platform);
			}
			
			// 将编译模式信息存储到Vuex
			this.$store.commit('setConfig', { currentMode });
			console.log('[config] ****************************');

			// 如果当前模式不是GSX_1，显示橙色警告
			if (currentMode.code !== 'GSX_1') {
				console.log('\n'); // 上边距
				console.log('%c[注意] 当前不是默认应用，请切换应用！', 'color: orange');
				console.log('\n'); // 下边距
			}

			this.$store.commit('setNavBarInfo',getNavBarInfo())
			// 版本号
			// #ifdef MP-WEIXIN
			this.$store.commit('setVersion',getAccountInfoSync().version)
			// #endif
			// #ifndef MP-WEIXIN
			this.$store.commit('setVersion',getSystemInfoSync().version)
			// #endif
			
			// 初始化应用参数
			this.initApplicationParams();
			
			// 检查本地登录状态
			this.checkLocalLoginStatus();
			
			// 自动登录
			this.autoLogin();
			
			// 检查页面是否存在，如果不存在则跳转到首页
			this.checkAndRedirect(e);
		},
		onShow: function(e) {
			// 页面显示时也检查页面是否存在
			this.checkAndRedirect(e);
		},
		onHide: function() {

		},
		methods: {
			// 检查页面是否存在，不存在则跳转到首页
			checkAndRedirect(e) {
				if (e && e.path) {
					try {
						// 获取当前页面路径
						const currentPath = e.path;
						// 检查是否在pages.json中注册
						const pagesInfo = require('./pages.json');
						const pages = pagesInfo.pages || [];
						
						// 检查当前路径是否在pages列表中
						const pageExists = pages.some(page => {
							return page.path === currentPath || currentPath.startsWith(page.path + '?');
						});
						
						if (!pageExists) {
							console.log('当前页面不存在，跳转到首页:', currentPath);
							// 使用setTimeout避免在onLaunch阶段过早调用路由方法
							setTimeout(() => {
								uni.reLaunch({
									url: '/app/index/index'
								});
							}, 100);
						}
					} catch (error) {
						console.error('页面检查出错:', error);
					}
				}
			},
			// 初始化应用参数
			initApplicationParams() {
				// 获取应用参数并存储到Vuex中
				initAppParams()
					.then(params => {
						// 将参数存储到Vuex中
						this.$store.commit('setAppParams', params);
						console.log('应用参数初始化完成，已存储到Vuex');
					})
					.catch(err => {
						console.error('应用参数初始化失败:', err);
						// 即使失败也初始化一个空对象
						this.$store.commit('setAppParams', {});
					});
			},
			// 检查本地登录状态
			checkLocalLoginStatus() {
				const token = uni.getStorageSync('TOKEN');
				const userInfo = uni.getStorageSync('USER_INFO');
				const tokenTime = uni.getStorageSync('TOKEN_TIME');
				
				if (token && userInfo && tokenTime) {
					const now = Date.now();
					const tokenAge = now - tokenTime;
					const validDuration = 5.5 * 60 * 60 * 1000; // 5.5小时，与新认证管理器保持一致
					
					if (tokenAge < validDuration) {
						console.log('检测到本地登录信息且未过期，恢复登录状态');
						this.$store.commit('setUserInfo', userInfo);
						this.$store.commit('setLoginStatus', true);
					} else {
						console.log('本地token已过期，清除缓存');
						uni.clearStorageSync();
					}
				}
			},
			// 自动登录
			autoLogin() {
				// 如果已经有token，则跳过自动登录
				const token = uni.getStorageSync('TOKEN');
				if (token) {
					console.log('已有登录token，跳过自动登录');
					return;
				}
				
				console.log('开始自动登录...');
				
				// #ifdef MP-WEIXIN
				uni.login({
					provider: 'weixin',
					success: (loginRes) => {
						console.log('微信登录成功，开始发送登录请求');
						
						// 获取用户信息
						uni.getUserInfo({
							success: (userInfo) => {
								this.sendLoginRequest(loginRes.code, userInfo.userInfo);
							},
							fail: (err) => {
								console.log('获取用户信息失败，仅使用code登录');
								this.sendLoginRequest(loginRes.code);
							}
						});
					},
					fail: (err) => {
						console.error('微信登录失败:', err);
					}
				});
				// #endif
				
				// #ifdef MP-ALIPAY
				uni.login({
					provider: 'alipay',
					success: (loginRes) => {
						console.log('支付宝登录成功，开始发送登录请求');
						this.sendLoginRequest(loginRes.code);
					},
					fail: (err) => {
						console.error('支付宝登录失败:', err);
					}
				});
				// #endif
				
				// #ifdef H5
				console.log('H5平台，跳过小程序登录流程');
				// H5平台使用新的微信认证管理器
				this.initWechatH5Auth();
				// #endif
			},
			
			// 发送登录请求
			sendLoginRequest(code, userInfo = null) {
				let url = '';
				// #ifdef MP-WEIXIN
				url = 'apis/client/auth/login-wechat';
				// #endif
				// #ifdef MP-ALIPAY
				url = 'apis/client/auth/login-alipay';
				// #endif
				
				const requestData = {
					code: code
				};
				
				// 如果有用户信息，添加到请求数据中
				if (userInfo) {
					requestData.nickname = userInfo.nickName || '';
					requestData.gender = userInfo.gender || 0;
				}
				
				uni.request({
					url: process.uniEnv.baseUrl + url,
					header: {
						"content-type": 'application/json',
						"x-app-code": process.uniEnv.appID
					},
					data: requestData,
					method: 'POST',
					success: (res) => {
						if (res.data.code === 0) {
							console.log('自动登录成功');
							// 缓存登录信息
							uni.setStorageSync('TOKEN', res.data.data.token);
							uni.setStorageSync('TOKEN_TIME', Date.now()); // 记录token获取时间
							// 根据API响应结构保存用户信息
							const userData = res.data.data.member || res.data.data || {};
							uni.setStorageSync('USER_INFO', userData);
							
							// 更新Vuex状态
							this.$store.commit('setUserInfo', userData);
							this.$store.commit('setLoginStatus', true);
						} else {
							console.log('自动登录失败:', res.data.message || res.data.msg);
						}
					},
					fail: (err) => {
						console.error('自动登录请求失败:', err);
					}
				});
			},
			
			// 初始化微信H5认证
			async initWechatH5Auth() {
				// #ifdef H5
				try {
					console.log('🚀 初始化微信H5认证管理器...');
					
					// 动态导入认证管理器
					const authManagerModule = await import('@/lib/wechat-h5-auth-manager.js');
					const authManager = authManagerModule.default;
					
					// 初始化管理器
					const initSuccess = authManager.init();
					
					if (initSuccess) {
						console.log('✅ 微信H5认证管理器初始化成功');
						
						// 延迟自动登录检查，确保页面完全加载
						setTimeout(async () => {
							try {
								await authManager.autoLogin();
								console.log('🎉 微信H5自动登录检查完成');
							} catch (error) {
								console.error('❌ 微信H5自动登录失败:', error);
							}
						}, 500);
					} else {
						console.log('⚠️ 微信H5认证管理器初始化跳过（非微信环境或其他原因）');
					}
				} catch (error) {
					console.error('❌ 微信H5认证管理器加载失败:', error);
				}
				// #endif
			}
		}
	}
</script>

<style lang="scss">
	@import "@/uni_modules/uview-ui/index.scss";
	@import "@/lib/app.scss";
</style>